import MagstimTableTreatmentHistoryBase from './MagstimTableTreatmentHistoryBase';

import { CurrentLang } from 'common';

class MagstimTableTreatmentArchive extends MagstimTableTreatmentHistoryBase {

    getColumns(dataIsEmpty) {
		var retVal = super.getColumns(dataIsEmpty);
		retVal.push({ title: CurrentLang().treatment_history_table_columnname_planName, property: 'planName', isSearchable: true });
        return retVal;
	}
	
}

export default MagstimTableTreatmentArchive;